// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import "babel-polyfill";
import VueClipboard from 'vue-clipboard2';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vue2OrgTree from 'vue2-org-tree';
import 'vue2-org-tree/dist/style.css'

/*复制插件*/
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(ElementUI);
Vue.use(VueAxios,axios);

Vue.use(Vue2OrgTree);
Vue.config.productionTip = true;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js